import { render, staticRenderFns } from "./UploaderReuploadButton.vue?vue&type=template&id=164187d5&scoped=true&lang=pug"
import script from "./UploaderReuploadButton.vue?vue&type=script&lang=ts"
export * from "./UploaderReuploadButton.vue?vue&type=script&lang=ts"
import style0 from "./UploaderReuploadButton.vue?vue&type=style&index=0&id=164187d5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164187d5",
  null
  
)

export default component.exports